import { render, staticRenderFns } from "./TaxDeductionToPay.vue?vue&type=template&id=48133d16&scoped=true&"
import script from "./TaxDeductionToPay.vue?vue&type=script&lang=ts&"
export * from "./TaxDeductionToPay.vue?vue&type=script&lang=ts&"
import style0 from "./TaxDeductionToPay.vue?vue&type=style&index=0&id=48133d16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48133d16",
  null
  
)

export default component.exports